import React from 'react'

const EditLinkShortener = () => {
    return (
        <div>EditLinkShortener</div>
    )
}

export default EditLinkShortener